export default __webpack_public_path__ + "static/media/Grupos perfumes.f6d50dbb.png";